import { Box } from '@mui/material';
import ClientFleetDashboard from './clientPortal/ClientFleetDashboard';
import { PAGE_BACKGROUND, PAGE_AMBIENT_SX } from './clientPortal/clientPortalTheme';

const ClientPortal = () => (
  <Box
    sx={{
      background: PAGE_BACKGROUND,
      minHeight: 'calc(100vh - 64px)',
      mx: -3,
      mt: -3,
      mb: -3,
      px: { xs: 2, sm: 3 },
      py: { xs: 2, sm: 3 },
      position: 'relative',
      overflow: 'hidden',
      ...PAGE_AMBIENT_SX
    }}
  >
    <Box sx={{ position: 'relative', zIndex: 1 }}>
      <ClientFleetDashboard />
    </Box>
  </Box>
);

export default ClientPortal;
